import React from 'react';
import styles from './HeadContainer.module.css'

import PropTypes from "prop-types"

export default function HeadContainer(props) {

    return (
        <div className={styles.header}>
            {props.children}
        </div>
    );
}

HeadContainer.propTypes = {
    children: PropTypes.element.isRequired
}